import { deterministicStringHash } from "@src/common/deterministic-string-hash";
import type { CardEntityDocumentId } from "@src/components/collaboration/document-id";
import type { AuthProvider, CardType, PromptLengthBucket } from "./types";

export function getAuthProvider(sub: string | undefined): AuthProvider {
	if (!sub) return "other";
	if (sub.startsWith("google-oauth2|")) return "google";
	if (sub.startsWith("auth0|")) return "email";
	return "other";
}

export function getPromptLengthBucket(text: string): PromptLengthBucket {
	const len = text.trim().length;
	if (len === 0) return "empty";
	if (len <= 20) return "1_20";
	if (len <= 100) return "21_100";
	return "100_plus";
}

export function getInputContentHash(
	promptText: string,
	contentCardIds: ReadonlyArray<CardEntityDocumentId | string>,
): string {
	const normalizedContentIds = contentCardIds
		.map((id) => (typeof id === "string" ? id : id.toString()))
		.sort()
		.join("\0");
	const input = `${promptText.trim()}\0${normalizedContentIds}`;

	return deterministicStringHash(input);
}

export function shapeTypeToCardType(shapeType: string): CardType {
	if (shapeType === "aicard") return "prompt";
	if (shapeType === "preprintCard") return "ai_output";
	return "note";
}

export function toPreprintVersionNum(versionId: number | null): number {
	return versionId ?? 0;
}

export function normalizeToolSelectedName(toolId: string): string {
	if (toolId === "card") {
		return "note";
	}
	if (toolId === "aicard") {
		return "prompt";
	}
	// tldraw's internal note tool is exposed in UI as "Sticker"
	if (toolId === "note") {
		return "sticker";
	}
	return toolId;
}
